import { render } from "./Command.vue?vue&type=template&id=512f7ba0&scoped=true"
import script from "./Command.vue?vue&type=script&lang=js"
export * from "./Command.vue?vue&type=script&lang=js"

import "./Command.vue?vue&type=style&index=0&id=512f7ba0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512f7ba0"]])

export default __exports__